import React, { PureComponent } from 'react'
import { connect } from 'react-redux'

import { actions as notificationActions } from 'components/handlers/notification/notificationHandlerRedux'

import { Drawer, Toolbar, Button } from 'lib/react-md'

import './CardContainer.css'

class CardContainer extends PureComponent {
	state = {
		drawer: {
			props: {
				position: 'right',
				visible: false,
			},
			title: "",
			actions: null,
		},
		confirmDelete: false
	};

	handleDrawerVisibility = visible => this.setState({
		drawer: { ...this.state.drawer, props: { ...this.state.drawer.props, visible }}
	});

	openDrawer = () => this.handleDrawerVisibility(true);
	closeDrawer = () => this.handleDrawerVisibility(false);
	toggleDrawer = () => this.handleDrawerVisibility(!this.state.drawer.props.visible);

	onClose = () => {
		const { proceed, success, error } = this.EditComponent.queryClose();

		if (proceed) {
			this.closeDrawer();
			if (success) this.props.addInfoToast(success);
		} else {
			if (error) this.props.addErrorToast(error);
		}
	};

	onDeleteConfirm = () => this.setState({ confirmDelete: true });
	onDeleteCancel = () => this.setState({ confirmDelete: false });
	onDelete = () => {
		const { node, actionHandler } = this.props;
		const { deleteNodeFromPayload } = actionHandler;

		const { proceed, success, error } = this.EditComponent.queryDelete();

		if (proceed) {
			this.closeDrawer();
			return deleteNodeFromPayload(node).then(
				() => this.props.addInfoToast(success || "Position gelöscht"),
				this.props.addErrorToast
			);
		} else if (error) this.props.addErrorToast(error);
	};

	onSaveAndClose = () => {
		const { node, actionHandler } = this.props;
		const { changeNodeProperty } = actionHandler;

		const { proceed, result, success, error } = this.EditComponent.querySaveAndClose();

		if (proceed) {
			this.closeDrawer();
			return changeNodeProperty(node, result.properties).then(
				() => this.props.addInfoToast(success || "Änderungen gespeichert"),
				this.props.addErrorToast
			);
		} else if (error) this.props.addErrorToast(error);
	};

	setTitle = title => this.setState({ title });
	setActions = actions => this.setState({ actions });

	componentDidUpdate(prevProps, prevState) {
		// hide confirmation buttons if window is closed
		if (this.state.confirmDelete && prevState.confirmDelete) this.onDeleteCancel();
	}

	renderHeader = () => {
		const { title, actions, confirmDelete } = this.state;

		return (
			<Toolbar
				ref={c => this.HeaderComponent = c}
				prominentTitle
				colored
				nav={<Button icon onClick={this.onClose}>close</Button>}
				title={title}
				actions={
					<div>
						{actions}
						{confirmDelete && <Button flat onClick={this.onDelete}>Löschen</Button>}
						{confirmDelete && <Button flat onClick={this.onDeleteCancel}>Abbrechen</Button>}
						{!confirmDelete && <Button icon onClick={this.onDeleteConfirm}>delete</Button>}
						<Button icon onClick={this.onSaveAndClose}>check</Button>
					</div>
				}
			/>
		)
	};

	render() {
		const { node, actionHandler, TemplateComponent=null, ViewComponent=null, EditComponent=null } = this.props;
		const { drawer } = this.state;

		return (
			<div className="card-container">
				{ EditComponent &&
					<Drawer
						onVisibilityChange={this.toggleDrawer}
						header={this.renderHeader()}
						type={Drawer.DrawerTypes.TEMPORARY}
						navItems={
							[<EditComponent
								ref={c => this.EditComponent = c}
								key="card-container-edit"
								node={node}
								setTitle={this.setTitle}
								setActions={this.setActions}
							/>]
						}
						navStyle={{paddingBottom: '80px'}}
						autoclose={false}
						{...drawer.props}
					/>
				}
				{TemplateComponent && <TemplateComponent node={node} actionHandler={actionHandler} onEdit={this.openDrawer} />}
				{ViewComponent && <ViewComponent node={node} actionHandler={actionHandler} />}
			</div>
		);
	}
}

export default connect(null, notificationActions)(CardContainer);




// WEBPACK FOOTER //
// ./src/components/cards/containers/CardContainer.jsx